<template lang="pug">
  section(class="separable")
    div.marginTop(class="container")
      el-row
        el-col(:span="24")
          div(class="card")
            div(class="card-header").titulo Central de comunicações
             el-button.btn-conversa(
              type="primary"
              @click="novoCadastro()"
              )
                i.fal.fa-comments
                |&emsp;Iniciar nova conversa
            div(class="card-body")
              p.bold Listagem de conversas
              el-row
                .divider
              .table-pointer
                el-table(
                  :data="conversas"
                  :default-sort = "{ prop: 'id', order: 'descending' }",
                  @sort-change="sort",

                  style="cursor: pointer"
                )
                  el-table-column(
                    min-width="40"
                  )
                  el-table-column(
                    label='Assunto',
                    prop='assuntoDescricao'
                    min-width="300"
                  )
                  el-table-column(
                    label='Responsável',
                    min-width='300',
                    prop='mensagemList[0].destinatario.pessoaFisica.nome'
                    :formatter='formatNome'
                  )
                  el-table-column(
                    label='Data de início da conversa',
                    sortable
                    min-width='210',
                    prop='dataInicioConversa',
                    :formatter='formatDataInicioConversa'
                  )
                  el-table-column(
                    label='Data da última resposta',
                    sortable
                    min-width='210',
                    prop='dataUltimaMensagem'
                    :formatter='formatDataResposta'
                  )
                  el-table-column(
                    label='Status',
                    min-width='100',
                    prop='statusDescricao'
                    sortable
                  )
                  el-table-column(
                    label='Ações',
                    min-width='100'
                    prop='id'
                  )
                    template(slot-scope='scope')
                      el-dropdown(trigger="click", size="small")
                        el-button(type='primary', size="mini")
                          | Ações
                          i.el-icon-arrow-down.el-icon--right
                        el-dropdown-menu(slot='dropdown')
                          div
                            el-dropdown-item
                              .flex(@click="$router.push({name: 'conversa/visualizar/', params: { idConversa: scope.row.id }})")
                                i.fas.fa-eye
                                |&nbsp; Visualizar conversa
</template>

<script>
import utils from '@/utils/utils'

export default {
  props: {
    conversas: {
      type: Array,
      required: true
    }
  },

  methods: {
    formatDataResposta (data) {
      if (!data.dataUltimaMensagem) {
        return '-'
      }
      return utils.formatDate(data.dataUltimaMensagem, 'DD/MM/YYYY HH:mm')
    },

    formatDataInicioConversa (data) {
      return utils.formatDate(data.dataInicioConversa, 'DD/MM/YYYY HH:mm')
    },

    formatNome (dados) {
      let destinatario

      if (dados.mensagemList.length > 1 && dados.mensagemList[dados.mensagemList.length - 1].destinatario) {
        destinatario = dados.mensagemList[dados.mensagemList.length - 1].remetente
      }

      if (destinatario && destinatario.pessoaFisica) {
        return destinatario.pessoaFisica.nome
      } else {
        return '-'
      }
    },

    novoCadastro () {
      this.$router.push({
        name: 'conversas/new'
      })
    },

    sort (data) {
      const ordenacaoFiltro = {
        ordenacao: '',
        tipo: ''
      }

      switch (data.prop) {
        case 'ultimaMensagem.dataEnviada':
          ordenacaoFiltro.ordenacao = 'ultimaMensagem.dataEnviada'
          break
        case 'statusDescricao':
          ordenacaoFiltro.ordenacao = 'statusDescricao'
          break
        default:
          ordenacaoFiltro.ordenacao = 'mensagemList[0].dataEnviada'
      }

      if (data.order === 'ascending') {
        ordenacaoFiltro.tipo = 'ASC'
      } else {
        ordenacaoFiltro.tipo = 'DESC'
      }

      this.$emit('sort', { ...ordenacaoFiltro })
    }
  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.titulo {
  color: #424242;
  font-size: 1.5rem;
  padding-bottom: 0;
}
.divider {
  border: 1px solid $border-color;
  margin-bottom: 2px;
}
.button {
  padding: 10px;
}
.bold {
  font-weight: bold;
}

@media (max-width: 780px) {
  .btn-conversa {
    margin-top: 20px;
  }

  .card .card-header {
    padding: 30px 0;
  }

  .marginTop {
    position: relative;
    left: 0px;
    top: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/comunicacao/ListagemConversas.vue